/* The page chrome lives in AuthLayout. What's left is the sign-in form itself. */

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
}

.submit {
  width: 100%;
}
